<template>
  <fragment>
    <v-select
      :label="label"
      v-bind="[defaultProps, $attrs]"
      v-on="$listeners"
      :attach="attach"
      :clearable="clearable"
    >
      <template #label>
        <slot name="label"
          >{{ label }}<span v-show="required" class="red--text"> *</span></slot
        >
      </template>
      <template #append>
        <slot name="append"></slot>
      </template>
    </v-select>
  </fragment>
</template>

<script>
import { defaultPropsInput } from "@/mixins/defaultPropsInput";

export default {
  name: "BaseSelect",
  inheritAttrs: false,
  props: {
    label: {
      type: String,
      default: "",
    },
    labelClass: {
      type: [Boolean, String],
      default: false,
    },
    required: {
      type: Boolean,
      default: false,
    },
    clearable: {
      type: Boolean,
      default: false,
    },
    variant: {
      type: String,
    },
    attach: {
      type: Boolean,
      default: true,
    },
  },
  mixins: [defaultPropsInput],
};
</script>
